import { render, staticRenderFns } from "./SampleOverviewItem.vue?vue&type=template&id=40d143da&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./SampleOverviewItem.vue?vue&type=script&lang=js&"
export * from "./SampleOverviewItem.vue?vue&type=script&lang=js&"
import style0 from "./SampleOverviewItem.vue?vue&type=style&index=0&id=40d143da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d143da",
  null
  
)

export default component.exports